import { useParams, useNavigate } from "react-router-dom";
import { ObjectInfo } from "@/components/ObjectInfo";
import { hasSession } from "@/lib/api";

export default function ObjectInfoPage() {
  const { module, id } = useParams();
  const navigate = useNavigate();
  const token = hasSession();
  if (!token) {
    return (
      <div className="min-h-screen bg-[#0F172A] text-slate-100 flex flex-col items-center justify-center gap-4 p-6 text-center">
        <div className="text-lg font-semibold">Zaloguj się, aby zobaczyć szczegóły obiektu</div>
        <div className="text-sm text-slate-400">Zeskanowano kod QR obiektu. Wymagane logowanie.</div>
        <div className="flex gap-3">
          <a href="/m" className="bg-cyan-600 hover:bg-cyan-500 rounded-lg px-4 py-2 font-medium">Logowanie montera</a>
          <a href="/login" className="bg-slate-700 hover:bg-slate-600 rounded-lg px-4 py-2 font-medium">Logowanie biura</a>
        </div>
      </div>
    );
  }
  return <ObjectInfo module={module} id={id} onClose={() => navigate(-1)} />;
}
